import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["select", "description", "content"]

    connect() {
        this.update()
    }

    update() {
        const content = this.contentTargets.find((template) => template.dataset.theme === this.selectTarget.value)
        this.descriptionTarget.innerHTML = ""
        if (content) {
            this.descriptionTarget.appendChild(content.content.cloneNode(true))
        }
        this.descriptionTarget.hidden = !this.descriptionTarget.textContent.trim()
    }
}
